<template>
  <v-layout align-center wrap>
    <v-flex align-center xs2 v-for="n in 10" class="mr-2 mt-4">
      <v-card>
        <v-card-media
          class="white--text"
          height="200px"
          src="/static/tache.jpg"
        >
          <v-container fill-height fluid>
            <v-layout fill-height>
              <v-flex xs12 align-end flexbox>
                <span class="headline">Titre tableau</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-media>
        <v-card-title>
          <div>
            <span class="grey--text">Tache(s) 100</span><br />
            <span>A faire: 20</span><br />
            <span>En cours : 20</span><br />
            <span>Termine: 20</span><br />
          </div>
        </v-card-title>
        <v-card-actions>
          <v-btn flat color="orange">Detail</v-btn>
          <v-btn flat color="orange">Modifier</v-btn>
          <v-btn flat color="orange">Supprimer</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Loading from "@/components/Loading";

export default {
  components: { Loading },
  props: {
    show: {
      type: Boolean
    },

    listeTableaux: {
      type: Array
    }
  },
  name: "TableauTache",
  data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      racourcis: [
        { path: "/tableTache", text: "Tableaux des taches", disabled: false }
      ]
    };
  },

  methods: {
    loadChantier() {}
  },

  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/gestionTache/TableauTache.vue